/** @format */

import type { UserFormData } from 'src/types';

const hasText = (value: unknown): boolean => Boolean(typeof value === 'string' && value.trim());

export type ProfileCompletionOptions = {
  hasProfilePicture?: boolean;
};

export const PROFILE_COMPLETION_FIELDS: Array<{
  selector: string;
  isCompleted: (data: UserFormData | null | undefined, options?: ProfileCompletionOptions) => boolean;
}> = [
  {
    selector: '#profilePictureUploadBtn',
    isCompleted: (_data, options) => Boolean(options?.hasProfilePicture)
  },
  {
    selector: 'input[name="firstName"]',
    isCompleted: data => hasText(data?.firstName)
  },
  {
    selector: 'input[name="lastName"]',
    isCompleted: data => hasText(data?.lastName)
  },
  {
    selector: 'input[name="company"]',
    isCompleted: data => hasText(data?.company)
  },
  {
    selector: 'input[name="street"]',
    isCompleted: data => hasText(data?.address?.street)
  },
  {
    selector: 'input[name="postalCode"]',
    isCompleted: data => hasText(data?.address?.postalCode)
  },
  {
    selector: 'input[name="city"]',
    isCompleted: data => hasText(data?.address?.city)
  },
  {
    selector: 'input[name="country"]',
    isCompleted: data => hasText(data?.address?.country)
  }
];

export function getProfileCompletionPercentage(
  userData: UserFormData | null | undefined,
  options?: ProfileCompletionOptions
): number {
  const totalFields = PROFILE_COMPLETION_FIELDS.length;
  if (totalFields === 0) return 0;
  const completedFields = PROFILE_COMPLETION_FIELDS.filter(field =>
    field.isCompleted(userData, options)
  ).length;
  return Math.round((completedFields / totalFields) * 100);
}

export function getFirstIncompleteProfileFieldSelector(
  userData: UserFormData | null | undefined,
  options?: ProfileCompletionOptions
): string | null {
  const firstIncompleteField = PROFILE_COMPLETION_FIELDS.find(
    field => !field.isCompleted(userData, options)
  );
  return firstIncompleteField?.selector ?? null;
}
